module.exports = __webpack_public_path__ + "img/display spk.8826c4cf.jpg";